module.exports = __webpack_public_path__ + "static/media/solution_banner_4_kf.c7137f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/solution_banner_4_kf.png
// module id = 584
// module chunks = 0